import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import { translate } from "react-i18next";
import InsertCity from "../../../components/cityComponent/insertCity.component";
import { titles } from "./citymaster.constants";

class AddCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/city");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.state.title === 'add_title' ? titles.add : titles.edit} LinkName="/city" />
        <div className="m-2">
          <InsertCity
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("city")(AddCity);
